













import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
// @ts-ignore
import skyconText from '@/utils/skyconText.js'
import ForecastData from '@/service/ForecastData'
export default Vue.extend({
    props: ['longitude', 'latitude'],
    computed: {
        lngLat(): any {
            const { longitude, latitude } = this
            return { longitude, latitude }
        },
    },
    watch: {
        lngLat() {
            this.getData()
        },
    },
    data() {
        return {
            data: {},
        }
    },
    created() {
        this.getData()
    },
    methods: {
      async getData(){
       const hourData =   await ForecastData.getHourly(this.lngLat.latitude,this.lngLat.longitude)
        this.data = hourData
      }
  
    },
})
